import ModalGraficos from '@core/components/ModalGraficos';
import { Grid } from '@material-ui/core';
import { GestaoEnvioContext } from 'app/main/gestaoenvio/GestaoEnvioContext';
import moment from 'moment';
import React, { useContext } from 'react';
import { GestaoEnvioModais } from '../GestaoEnvioModais';
import GestaoEnvioGraficoOrigem from './GestaoEnvioGraficoOrigem';
import GestaoEnvioGraficoSituacao from './GestaoEnvioGraficoSituacao';

const GestaoEnvioGraficosModal = () => {
  const [modal, setModal] = useContext(GestaoEnvioContext).modal;
  const [filtroAvancado] = useContext(GestaoEnvioContext).filtroAvancado;
  const [somatorios] = useContext(GestaoEnvioContext).somatorios;
  const [search] = useContext(GestaoEnvioContext).search;

  const handleClose = () => {
    setModal('');
  };

  const primeiraLetraMaiuscula = (palavra) => {
    const formatada = palavra[0].toUpperCase() + palavra.substr(1).toLowerCase();
    return formatada.replaceAll('_', ' ');
  };

  const labelTipoEnvio = (tipoEnvio) => {
    switch (tipoEnvio) {
      case 'ORDEM_SERVICO':
        return 'Ordem de serviço';
      case 'VENDA':
        return 'Orçamento';
      case 'REGUA_COBRANCA_PASSO':
        return 'Régua de cobrança';
      case 'CONTAS_RECEBER':
        return 'Cobrança';
      case 'FATURAMENTO_VENDA':
        return 'Nota fiscal';
      default:
        return '';
    }
  };

  const getFiltroUtilizado = () => {
    const filtros = [];

    if (search) {
      filtros.push(`Pesquisa: "${search}"`);
    }

    if (filtroAvancado?.periodoEnvioInicio) {
      filtros.push(
        `Período de envio: "${moment(filtroAvancado?.periodoEnvioInicio).format('DD/MM/YYYY')} a ${moment(
          filtroAvancado?.periodoEnvioFim
        ).format('DD/MM/YYYY')}"`
      );
    }

    if (filtroAvancado?.email) {
      filtros.push(`E-mail: "${filtroAvancado?.email}"`);
    }

    if (filtroAvancado?.cliente?.nome) {
      filtros.push(`Cliente: "${primeiraLetraMaiuscula(filtroAvancado?.cliente?.nome)}"`);
    }

    if (filtroAvancado?.situacaoEnvio) {
      filtros.push(`Situação: "${primeiraLetraMaiuscula(filtroAvancado?.situacaoEnvio)}"`);
    }

    if (filtroAvancado?.tipoEnvio) {
      filtros.push(`Tipo de envio: "${labelTipoEnvio(filtroAvancado?.tipoEnvio)}"`);
    }

    return filtros?.length !== 0 ? `Filtros utilizados: ${filtros.join(', ')}` : '';
  };

  return (
    <ModalGraficos
      titulo="Indicadores da gestão de envios"
      open={modal === GestaoEnvioModais.indicadores}
      onClose={handleClose}
      nomeArquivo="Indicadores da gestão de envios"
      rodape={getFiltroUtilizado()}
    >
      <div style={{ padding: 16, alignItems: 'center', justifyContent: 'center' }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <GestaoEnvioGraficoSituacao values={somatorios} />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <GestaoEnvioGraficoOrigem values={somatorios} />
          </Grid>
        </Grid>
      </div>
    </ModalGraficos>
  );
};

export default GestaoEnvioGraficosModal;
